<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'OtherFun'
};
</script>

<style lang="less" scoped></style>